import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TagManager from 'react-gtm-module';
import { useActiveUser, useCustomerId } from '@/containers/App';
import { useIsInternalUser } from './useIsInternalUser';
import { useLocaleState } from '@/containers/LanguageProvider/hooks/useLocaleState';

export const useGaTracker = (): void => {
  const location = useLocation();
  const { locale } = useLocaleState();
  const [initialized, setInitialized] = useState(false);
  const user = useActiveUser();
  const userId = user?._id;
  const customerId = useCustomerId();
  const isInternalUser = useIsInternalUser();

  useEffect(() => {
    if (!window.location.href.includes('localhost')) {
      const envConfig = window.location.href.includes('app.enmon')
        ? { gtmId: 'GTM-KH6XH8K' }
        : {
            gtmId: 'GTM-KH6XH8K',
            auth: '0CyQTWvXHJESL4FG0b493g',
            preview: 'env-3',
          };
      TagManager.initialize(envConfig);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (!initialized) return;

    const userObj = user
      ? {
          id: user._id,
          cpid: customerId ?? null,
          resid: user.resellerId ?? null,
          favourites: user.favourites.map(favourite => favourite.pathname.replaceAll(/([a-f\d]{24})/gi, '{ObjectId}')),
        }
      : { id: null, cpid: null, resid: null, favourites: [] };

    TagManager.dataLayer({
      dataLayer: {
        user: userObj,
        internalUser: isInternalUser,
      },
    });
  }, [user, customerId, initialized, isInternalUser]);

  useEffect(() => {
    if (!(initialized && userId)) return;

    const page = {
      locale,
      title: document.title,
      fullPath: location.pathname,
    };

    TagManager.dataLayer({
      dataLayer: { page, internalUser: isInternalUser },
    });
    TagManager.dataLayer({ dataLayer: { event: 'page', internalUser: isInternalUser } });
  }, [initialized, location.pathname, locale, isInternalUser, userId]);
};
